import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "claas-contact-card",
  imports: [TranslatePipe],
  templateUrl: "./contact-card.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./contact-card.scss",
})
export class ContactCard {
  @Input()
  contact = {
    contactName: "",
    contactEmail: "",
    contactPhone: "",
    contactLink: "",
  };
}
